// 场景：三翼鸟采购
export const SCENE_SYNCG = 'SYNCG';
// 从工作台点击采购专区进入
export const SOURCE_MYSTORE = 'myStore'